import { authenticatedFetch, parseAuthenticatedJson } from './authenticatedFetch';
import { API_URL } from '../config';

export { API_URL };

export async function apiRequest(url: string, options: RequestInit = {}): Promise<any> {
  const response = await authenticatedFetch(url, options);
  return parseAuthenticatedJson(response);
}

export async function apiGet(url: string): Promise<any> {
  return apiRequest(url, { method: 'GET' });
}

export async function apiPost(url: string, data?: any): Promise<any> {
  return apiRequest(url, {
    method: 'POST',
    body: data ? JSON.stringify(data) : undefined,
  });
}

export async function apiPut(url: string, data?: any): Promise<any> {
  return apiRequest(url, {
    method: 'PUT',
    body: data ? JSON.stringify(data) : undefined,
  });
}

export async function apiDelete(url: string): Promise<any> {
  return apiRequest(url, { method: 'DELETE' });
}

export async function getCenters() {
  return apiGet(`${API_URL}/api/centers`);
}

export async function deleteCenter(id: number) {
  return apiDelete(`${API_URL}/api/centers/${id}`);
}

/** @deprecated Usar securityService.refreshSession() */
export async function refreshToken(): Promise<{ token: string }> {
  const { securityService } = await import('./securityService');
  const ok = await securityService.refreshSession();
  if (!ok) throw new Error('No se pudo refrescar el token');
  const token = localStorage.getItem('token');
  if (!token) throw new Error('No se pudo refrescar el token');
  return { token };
}
